var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-template-2"},[_c('div',{ref:"lineChart",staticClass:"line-chart"})])}
var staticRenderFns = []

export { render, staticRenderFns }